"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _luxon = require("luxon");

var _colors = require("../../constants/colors");

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

var _chartUtils = require("../../chartUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var HoverBody = function HoverBody(_ref) {
  var crosshairCoordinateValues = _ref.crosshairCoordinateValues,
      focusedBattery = _ref.focusedBattery,
      individualBatteryKeys = _ref.individualBatteryKeys,
      isToggleActive = _ref.isToggleActive,
      timeZone = _ref.timeZone;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.CrosshairDate, {
    dateMillis: crosshairCoordinateValues.x,
    timeZone: timeZone,
    dateFormat: _luxon.DateTime.DATETIME_SHORT
  }), isToggleActive && /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
    stroke: _colors.DARK_GREEN
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginRight: '5px',
      textTransform: 'capitalize'
    }
  }, "Average:"), /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.BatteryPercentage, {
    batteryPercentage: crosshairCoordinateValues.average
  }, (0, _lodash.isNil)(crosshairCoordinateValues.average) ? 'No Reading' : " ".concat((0, _chartUtils.getFormattedValue)(crosshairCoordinateValues.average, 1), "%"))), !isToggleActive && individualBatteryKeys.map(function (battery) {
    return /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.HoverLineKey, {
      key: battery,
      stroke: focusedBattery === battery ? _colors.DARK_GREEN : _colors.LIGHT_GREEN
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginRight: '5px',
        textTransform: 'capitalize'
      }
    }, "".concat(battery, ":")), /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.BatteryPercentage, {
      batteryPercentage: crosshairCoordinateValues[battery]
    }, (0, _lodash.isNil)(crosshairCoordinateValues[battery]) ? 'No Reading' : " ".concat((0, _chartUtils.getFormattedValue)(crosshairCoordinateValues[battery], 1), "%")));
  }));
};

HoverBody.propTypes = {
  crosshairCoordinateValues: _propTypes["default"].shape({
    average: _propTypes["default"].number,
    x: _propTypes["default"].number
  }).isRequired,
  focusedBattery: _propTypes["default"].string.isRequired,
  individualBatteryKeys: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  isToggleActive: _propTypes["default"].bool.isRequired,
  timeZone: _propTypes["default"].string.isRequired
};
var _default = HoverBody;
exports["default"] = _default;